"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeSource = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const changeSource = exports.changeSource = (0, _actionGenerator.actionGenerator)(_types.ESourceActionType.Change);